import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import CustomerPanel from "../components/customers/CustomerPanel";
import { ArrowLeft, ArrowUpRight } from "lucide-react";

// A customer account on its own page: what the portfolio opens, and the only way in for whoever follows customers without seeing
// the prospects (customers:* never opens the fiche, D-33). The « Client » tab of the fiche shows the same panel.
export default function CustomerPage() {
  const { prospectId } = useParams();
  const [account, setAccount] = useState(null);

  return (
    <div className="space-y-4" data-testid="customer-page">
      <Link to="/clients" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-900"><ArrowLeft size={14} />Clients</Link>
      {account && (
        <div className="flex flex-col gap-1 md:flex-row md:items-end md:justify-between">
          <div className="min-w-0">
            <h1 className="font-display font-bold text-2xl text-slate-900 break-words" data-testid="customer-page-title">{account.pharmacy.name}</h1>
            {(account.pharmacy.commune || account.pharmacy.region) && (
              <p className="text-sm text-slate-500">{[account.pharmacy.commune, account.pharmacy.region].filter(Boolean).join(" · ")}</p>
            )}
          </div>
          {account.can_open_prospect && (
            <Link to={`/prospects/${account.prospect_id}`} className="text-sm text-jamora hover:underline inline-flex items-center gap-1" data-testid="customer-open-prospect">
              Ouvrir la fiche de la pharmacie <ArrowUpRight size={13} />
            </Link>
          )}
        </div>
      )}
      <CustomerPanel prospectId={prospectId} onLoaded={setAccount} />
    </div>
  );
}
